import { checkAccess } from '@/src/utils/roleUtils';
import { useEffect, useState } from 'react';
import { useRolesAccessContext } from '../../context/RolesAccessContext';
import Section from './Section';
import { NewBoxSection } from '../../Interfaces/system/Generic.interfaces';

type SectionListProps = {
  boxes: NewBoxSection[];
};

const SectionList = ({ boxes }: SectionListProps) => {
  const [sections, setSections] = useState<JSX.Element[]>([]);
  const { rolesAcess } = useRolesAccessContext();

  useEffect(() => {
    const list = [];
    boxes.forEach((section) => {
      const hasAccess = section.access
        ? checkAccess(rolesAcess ?? [], section.access)
        : true;

      if (hasAccess) {
        list.push(
          <div className="col h-260px" key={section.section}>
            <Section
              sectionName={section.section}
              formList={section.forms || []}
            />
          </div>
        );
      }
    });

    for (let i = 0; i < 5; i++) {
      list.push(
        <div className="col" key={i}>
          <div className="min-w-300px" />
        </div>
      );
    }

    setSections(list);
  }, []);

  return <div className="grid gap-3">{sections}</div>;
};

export default SectionList;
